import React, { useEffect, useState } from "react";
import { loadEvents, useEventsContext } from "../../../../context/eventsContext";
import EventHero from "../EventHero";
import { Event } from "../../../../context/eventsContext/reducer";
import EventPreview from "../EventPreview";

const RelatedEvents = (props: {
  parentEvent?: Event,
  className?: string
}) => {
  const {
    state: { loading, upcoming_events },
    dispatch: eventsDispatch,
  } = useEventsContext();
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if(!firstLoad) return;
    if(!loading && !upcoming_events) {
      loadEvents(eventsDispatch);
      setFirstLoad(false);
    }
  }, [loading, eventsDispatch, upcoming_events]);

  const otherEvents = () => {
    if(!upcoming_events) return [];
    return upcoming_events.filter((e) => e.id !== props.parentEvent.id);
  }

  return (
    <div>
      {
        !loading && otherEvents().length > 0 &&
        <div>
          <div className="font-light text-xl border-b border-gray-100 pb-2 mb-4 mt-8">
            Upcoming Events
          </div>
          <div className="space-y-4">
            {
              upcoming_events && upcoming_events.length > 0 &&
              otherEvents().map((event) => (
                <EventPreview
                  key={event.slug}
                  hideImage={true}
                  event={event}
                />
              ))
            }
          </div>
        </div>
      }
    </div>
  )
}

export default RelatedEvents;
